module.exports = __webpack_public_path__ + "img/apple_pick_hand_hold_original.49b9068d.jpg";